var ProductTags=$("#Product-specification-recommendation").data("tags");
var Ezpid=$("#Product-specification-recommendation").data("ezpid");
console.log(ProductTags)
console.log(Ezpid)
if(ProductTags!=""){
  jQuery.getJSON("/search/suggest.json",{
    "q":ProductTags,
    "resources":{
      "type":"product",
      "limit":4,
      "options":{"fields":"tag"}
    }
  }).done(function(response){
    var productSuggestions=response.resources.results.products;
    if(productSuggestions.length>1 && productSuggestions.length>0){
      $.each(productSuggestions,function(key,val){
        jQuery.getJSON("/products/"+val.handle+".js",function(product){
          console.log(product)
          if(product.id!=Ezpid){NestRecommendProduct(product)}
        })
      })
    }else{
      $(".recommendation.Lx_sc").css("display","none");
  $("#Product-specification").remove();
    }
  })
}else{
  $(".recommendation.Lx_sc").css("display","none");
  $("#Product-specification").remove();
}
function NestRecommendProduct(product){
  $("#Product-specification .interlinkage").attr("title",product.title);
  $("#Product-specification .interlinkage").attr("href",product.url);
  $("#Product-specification .no-js").attr("src",product.images[0]);
  $("#Product-specification .productNameItem").html(product.title);
  $("#Product-specification .sales_price").html((product.price*0.01).toFixed(2));
  if(product.compare_at_price!=null){
    $("#Product-specification .original_cost").html((product.compare_at_price*0.01).toFixed(2))
  }
  $("#Product-specification .link_by_Now").attr("href",product.url);
//   $("#Product-specification .product_revices").attr("data-id",product.id);
  $("#Product-specification-recommendation").append($("#Product-specification").html())
};

/*星級評論start*/
$(function(){
    var timer;
    timer=setInterval(function(){ 
      var num=0;
	  var length = $(".recommendation .related-product .star-review").length;
      $(".recommendation .related-product .star-review").each(function(){
        var starEl=$(this).find(".spr-badge");
        if(starEl.html()){
          	num++;
        }
      })
      if(length==num){
          changeStar();
          clearInterval(timer)
      }
    }, 1000);
   function changeStar(){
  	$(".recommendation .related-product .star-review").each(function(){
        var el=$(this).find(".spr-badge");
         if(el.html()){
           var grade=el.attr("data-rating");
            if(grade){
              var gradeStr=grade+'';
              gradeStr=grade.substring(0,3)
              
               el.find(".spr-badge-caption").html(gradeStr+" grade");
              
              if(grade==5){
                
               }else if(grade<5 && grade>=4){
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(4);
                  elS.append("<span style='width:50%'></span>");

               }else if(grade<4 && grade>=3){
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(3);
                  elS.append("<span style='width:50%'></span>");
               }else if(grade<3 && grade>=2){
                  el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(2);
                  elS.append("<span style='width:50%'></span>");
               }else if(grade<2 && grade>=1){
                  el.find(".spr-badge-starrating .spr-icon").eq(2).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(1);
                  elS.append("<span style='width:50%'></span>");
               }else{
                  el.find(".spr-badge-starrating .spr-icon").hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(0);
                  elS.show();
                  elS.append("<span style='width:50%'></span>");
               }
             }
     	}  
  	
     })
     $(".recommendation .star-review .spr-badge").show();
     
  }
  
})
/*星級評論end*/